import axios from 'axios';
import { PixVerificationResponse } from './interfaces';

export const requestPremiumPixPayment = (payload: any): Promise<any> =>
  axios.post('v1/premium/web/purchases', payload.toJSON());

export const verifyPremiumPixPayment = (
  purchaseID: string | null,
): Promise<any | PixVerificationResponse> => {
  return axios.get(`v1/premium/purchases/${purchaseID}`);
};
